export const TVSPIX_V2_SNIPPETS = {
  install: `
  <script src="https://assets.tvspix.com/tvscientific-pix-o-d0f34b1e-d90e-48ea-be1b-e3701e825d7d.js" async> </script>
`,
  universal_pixel: `
  <script>
    tvsci.fireUniversalSitePixel();
  </script>
  `,
  lead_generated: `
  <script>
    tvsci.fireCustomPixelWithAutoOrderId('lead_generated', {
      u5: "{{Last Touch Channel}}"    // OPTIONAL
    });
  </script>
  `,
  add_to_cart: `
  <script>
    tvsci.fireCustomPixelWithAutoOrderId('add_to_cart', {
      u5: "{{Last Touch Channel}}"      // OPTIONAL
    });
  </script>
  `,
  complete_registration: `
  <script>
    tvsci.fireCustomPixel('complete_registration', {
      u4: "{{Registration Id}}",        // REQUIRED
      u5: "{{Last Touch Channel}}",     // OPTIONAL
      u6: "{{Customer Id}}"             // OPTIONAL
    });
  </script>
  `,
  keyword_search: `
  <script>
    tvsci.fireCustomPixelWithAutoOrderId('keyword_search', {
      u5: "{{Last Touch Channel}}",      // OPTIONAL
      u12: "{{Keyword}}"                 // OPTIONAL
    });
  </script>
  `,
  start_checkout: `
  <script>
    tvsci.fireCustomPixelWithAutoOrderId('start_checkout', {
      u5: "{{LastTouchChannel}}"           // OPTIONAL
    });
  </script>
  `,
  trial_started: `
  <script>
    tvsci.fireCustomPixel('trial_started', {
      u4: "{{Trial Id}}",                  // REQUIRED
      u5: "{{Last Touch Channel}}",        // OPTIONAL
      u6: "{{Customer Id}}"                // OPTIONAL
    });
  </script>
  `,
  viewed_product: `
  <script>
    tvsci.fireCustomPixelWithAutoOrderId('viewed_product', {
      u5: "{{Last Touch Channel}}",         // OPTIONAL
      u12: "{{Product Name}}"               // OPTIONAL
    });
  </script>
  `,
  complete_purchase: `
  <script>
    tvsci.fireCompletePurchasePixel({
        orderId: "{{Order Id}}",                       // REQUIRED
        orderAmount: {{Order Amount}},                 // REQUIRED eg. 88.99
        lastTouchChannel: "{{Last Touch Channel}}"     // OPTIONAL
      });
  </script>
  `,
}



